<section class="office__search">
    <div class="office__search__content container py-4 px-0 px-md-4 px-lg-8">
        <div
            class="office__search__content__title d-flex mb-2 flex-row align-items-center justify-content-between"
        >
            <h2 class="m-0">{{ 'fe_office_search_title' | translate }}</h2>
            <span>{{ 'fe_office_search_indicates' | translate }}</span>
        </div>
        <fe-input
            #inputLocation
            [ngClass]="
                reservation.showDifferenteLocation ? 'mb-6' : 'mb-0 mb-md-6'
            "
            [isSelect]="true"
            [isSelectLocations]="true"
            [id]="'location'"
            [label]="'fe_office_search_input' | translate"
            (search)="onSearchLocations($event)"
            [groupBy]="'group'"
            [items]="reservation.locations"
            [selectType]="'typing'"
            [(ngModel)]="reservation.current.location"
            (ngModelChange)="onLocationChange($event)"
            [tabIndex]="'1000'"
            [textNotFound]="textNotFoundLocations"
            [loading]="loadingLocations"
            [customSelectSearchFn]="false"
        ></fe-input>
    </div>
</section>
